import type { ComponentProps } from 'react'
import { cn } from '@/utils/index.ts'

export function WorkspaceHeader({ className, ...props }: ComponentProps<'header'>) {
  return (
    <header
      {...props}
      className={cn(
        'border-border bg-surface flex h-15 shrink-0 items-center justify-between gap-3 overflow-x-auto border-b px-4 [&>div]:shrink-0',
        className
      )}
    />
  )
}
